import { ManualCommandDefinition } from "../../../services/manualCommandService";

export const manualCommandDefinitions: Record<string, ManualCommandDefinition> = {
  bea_retry_create_activity: {
    key: "bea_retry_create_activity",
    label: "beA-Retry-Aktivitäten erstellen",
    description: "Erstellt Aktivitäten für aktive beA-Retries.",
    commandName: "backoffice:bea:bea-retry-create-activity",
    project: "backoffice",
  },
  legalbird_handle_advocard_payments_without_case: {
    key: "legalbird_handle_advocard_payments_without_case",
    label: "Advocard-Zahlungen ohne Akte verarbeiten",
    description: "Verarbeitet offene Advocard-Zahlungen, die noch keiner Akte zugeordnet sind.",
    commandName: "legalbird:accounting:handle-advocard-payments-without-case",
    project: "legalbird",
  },
  legalbird_handle_advocard_payments_without_invoice: {
    key: "legalbird_handle_advocard_payments_without_invoice",
    label: "Advocard-Zahlungen ohne Rechnung verarbeiten",
    description: "Erstellt Rechnungen für offene Advocard-Zahlungen ohne bestehende Rechnung.",
    commandName: "legalbird:accounting:handle-advocard-payments-without-invoice",
    project: "legalbird",
    parameters: [
      {
        name: "olderThanXDays",
        label: "Älter als X Tage",
        type: "number",
      },
    ],
  },
  legalbird_prepare_advocard_controlling: {
    key: "legalbird_prepare_advocard_controlling",
    label: "Advocard-Controlling vorbereiten",
    description: "Bereitet Advocard-Controllingdaten für das gewählte Intervall vor.",
    commandName: "legalbird:controlling:prepare-advocard-controlling",
    project: "legalbird",
    parameters: [
      {
        name: "interval",
        label: "Intervall",
        type: "select",
        defaultValue: "lastWeek",
        options: [
          { label: "Heute", value: "today" },
          { label: "Diese Woche", value: "thisWeek" },
          { label: "Letzte Woche", value: "lastWeek" },
          { label: "Vorletzte Woche", value: "weekBeforeLastWeek" },
          { label: "Nächste Woche", value: "nextWeek" },
          { label: "Dieser Monat", value: "thisMonth" },
          { label: "Nächster Monat", value: "nextMonth" },
        ],
      },
    ],
  },
  legalbird_prepare_auxilia_controlling: {
    key: "legalbird_prepare_auxilia_controlling",
    label: "AUXILIA-Controlling vorbereiten",
    description: "Erstellt und versendet die monatliche AUXILIA-Sammelabrechnung für den gewählten Zeitraum.",
    commandName: "legalbird:controlling:prepare-auxilia-controlling",
    project: "legalbird",
    parameters: [
      {
        name: "interval",
        label: "Auswertungszeitraum",
        type: "select",
        defaultValue: "lastMonth",
        options: [
          { label: "Vormonat", value: "lastMonth" },
          { label: "Aktueller Monat", value: "thisMonth" },
        ],
      },
    ],
  },
};

export const manualCommands = Object.values(manualCommandDefinitions);
